import { MenuItem, Select } from "@mui/material";
import type { MetricValueSourceConfiguration } from "../../../../api/portfolioMonitoringTypes";
import UnsupportedField from "./UnsupportedField";

interface Props {
  value: string | undefined;
  onChange: (newValue: string) => void;
  valueSource: MetricValueSourceConfiguration;
  readOnly?: boolean;
  disabled?: boolean;
}

const getSelectOptions = (valueSource: MetricValueSourceConfiguration) => {
  const { allowedValues } = valueSource;
  if (allowedValues?.length) {
    return { options: allowedValues.map((val) => ({ value: val, label: val })) };
  }

  return { error: "Select options were not defined for this metric" };
};

const MetricSelectField = ({ value, onChange, valueSource, readOnly, disabled }: Props) => {
  const { options, error } = getSelectOptions(valueSource);
  if (error || !options) {
    return <UnsupportedField>{error}</UnsupportedField>;
  }

  return (
    <Select
      fullWidth
      disabled={disabled}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      sx={{ bgcolor: readOnly ? "background.grey" : undefined }}
    >
      {options.map(({ value, label }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default MetricSelectField;
